<template>
  <div class="flex-center">
    <div class="text-center">
      <div class="h5 main">플랜 변경</div>

      <div class="sub2" style="background-color:#eee;padding:16px;margin-top:24px;"
           v-if="service.status===10">현재 월 50,000원의 호스팅 상품만 결제하여, 고객 서비스는 노출중이나 관리자 솔루션은 이용하지 못하는 상태입니다.</div>

      <div style="margin-top:20px">
        <div class="text-left" style="margin:0 auto">
          <div v-for="(selector, idx) in optionArr1" :key="`option1-${idx}`">
            <div v-if="!selector.disabled">
              <div class="flex" style="border-right: 1px solid #e3e3e3">
                <!-- 옵션 정보 -->
                <div style="width:19%">
                  <div class="top-box" :style="topBoxStyle(idx)"></div>
                  <div class="table-item flex-between" v-for="(item, mb_idx) in selector.options[0].plan"
                       :key="`lable-${mb_idx}`" style="padding-left:16px;">
                    <div class="flex-align body4 sub3">{{ item.name }}</div>
                  </div>
                </div>
                <div v-for="(option, o_idx) in selector.options" :key="`op1-${o_idx}`" style="width:27%">
                  <div class="top-box content-item" :class="{'using-background-st': showUsingMemberShip(option)}"
                       v-if="!option.disabled">
                    <div class="h7 main text-center" style="margin-bottom:6px">{{ option.name }}
                      <span class="show-using-st" v-if="showUsingMemberShip(option)">이용중</span>
                    </div>
                    <div class="body5 sub3 text-center">{{ option.desc }}</div>
                  </div>
                  <div :class="{'using-background-st': showUsingMemberShip(option)}">
                    <div class="table-item flex-between" v-for="(item, mb_idx) in option.plan" :key="`mb-${mb_idx}`">
                      <div class="body4-medium main col-12 text-center">{{ item.text }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-info" v-if="service.service_order.trial">
                <div class="event-btn body6-bold">EVENT</div>
                <div class="body4-bold primary">무료체험 기간 내 3,6,12개월 플랜 선택 및 결제 시 혜택 제공!</div>
              </div>

              <div class="flex" style="border-right: 1px solid #e3e3e3" :style="[!(order_product.date_unit>=3 && service.service_order.trial)?{'border-bottom':'1px solid #e3e3e3'}:'']">
                <!-- 옵션 정보 -->
                <div style="width:19%">
                  <div class="middle-box flex-align">
                    <div class="body4 sub3">플랜 선택</div>
                  </div>
                </div>
                <template v-for="(option, o_idx) in selector.options">
                  <div class="middle-box sub-box" :key="`op1-${o_idx}`" v-if="!option.disabled" style="width:27%">
                    <div class="sub-item unselect" @click="selectOpt(option, 1)"
                         :class="[selectedOpt&&selectedOpt.id===option.id && selectedOpt.date_unit===1 ? 'sub-select' : 'sub-unselect',
                         !service.service_order.trial && showUsingOption(option, 1)?'using-background-st1': '']">
                      <div class="sub-item-check"
                           v-if="selectedOpt&&selectedOpt.id===option.id && selectedOpt.date_unit===1">
                        <img :src="svgSrc('u_check')" class="svg-white">
                      </div>
                      <div class="flex-between">
                        <div class="size-13 sub">1개월
                          <span class="show-using-st" v-if="showUsingOption(option, 1)">이용중</span>
                        </div>
                        <div class="size-12 sub4" style="text-decoration:line-through"
                        >{{ option.price | currencyNum }}원
                        </div>
                      </div>
                      <div class="text-right main size-14">
                        <span class="weight-700">{{ option.price | currencyNum }}</span>
                        <span>원</span><span class="sub">/월</span></div>
                    </div>
                    <div v-for="(sub,s_idx) in option.subscriptions" :key="'sub-'+s_idx">
                      <div class="sub-item unselect" @click="selectOpt(option, sub.date_unit)"
                           :class="[selectedOpt&&selectedOpt.id===option.id && selectedOpt.date_unit===sub.date_unit  ? 'sub-select' : 'sub-unselect',
                           !service.service_order.trial && showUsingOption(option, sub.date_unit)?'using-background-st1': '']">
                        <div class="sub-item-check"
                             v-if="selectedOpt&&selectedOpt.id===option.id && selectedOpt.date_unit===sub.date_unit">
                          <img :src="svgSrc('u_check')" class="svg-white">
                        </div>
                        <div class="flex-between">
                          <div class="size-13 sub">{{ sub.date_unit }}개월
                            <span class="show-using-st" v-if="showUsingOption(option, sub.date_unit)">이용중</span>
                          </div>
                          <div class="size-12 sub4" style="text-decoration:line-through"
                          >{{ option.price | currencyNum }}원
                          </div>
                        </div>
                        <div class="size-14 flex-end">
                          <div class="primary weight-700" style="margin-right:4px">{{ sub.discount_rate }}%</div>
                          <div class="main">
                            <span class="weight-700">{{ sub.price | currencyNum }}</span>
                            <span>원</span><span class="sub">/월</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <template>
                <div class="box-info" style="background-color:black" v-if="order_product.date_unit>=3 && service.service_order.trial">
                  <div class="body4-bold" style="color:white">⚡️ 무료체험 기간에만 한정적으로 적용되는 혜택으로, 이후 다시 동일한 조건을 만나 볼 수 없어요!
                  </div>
                </div>

                <!-- 무료 혜택 -->
                <div class="flex" v-if="service.service_order.trial">
                  <div class="flex-align" style="width:19%"
                       :class="[order_product.date_unit>=3 ? 'bottom-box' : 'bottom-box2']">
                    <div class="body4 sub3">무료체험 기간 내 <br> 결제 시 혜택 선택</div>
                  </div>
                  <div v-if="order_product.date_unit>=3"
                       class="bottom-box sub-box border-right" style="width:81%;align-items: center;display: flex;justify-content: center;">
                    <div class="flex-align">
                      <div class="bottom-item unselect" :class="[trial_product.month_free?'sub-select' : 'sub-unselect']"
                           @click="selectTrialProduct('month_free')">
                        <div class="sub-item-check" v-if="trial_product.month_free">
                          <img :src="svgSrc('u_check')" class="svg-white">
                        </div>
                        <div class="body4-medium sub">무료 1개월 이용권 추가</div>
                        <div class="sub4 size-12 sub4" style="text-decoration:line-through;margin-top:28px">{{ freeMonthPrice | currency }}
                        </div>
                        <div>
                          <span class="sub size-14 weight-600">{{ 0 | currencyNum }}</span>
                          <span>원</span>
                        </div>
                      </div>

                      <div class="bottom-item unselect" style="margin-left:20px"
                           :class="[trial_product.app_porting?'sub-select' : 'sub-unselect']"
                           @click="selectTrialProduct('app_porting')">
                        <div class="sub-item-check" v-if="trial_product.app_porting">
                          <img :src="svgSrc('u_check')" class="svg-white">
                        </div>
                        <div class="body4-medium sub">앱포팅 및 등록 대행 할인 <br><span class="body4-medium">(android)</span></div>
                        <div class="sub4 size-12 sub4" style="text-decoration:line-through;margin-top:12px">{{ 3000000 |
                          currency }}
                        </div>
                        <div>
                          <span class="primary size-13 weight-600" style="margin-right:8px">{{ appPortingDiscount | currencyNum }}%</span>
                          <span class="sub size-14 weight-600">{{ appPortingPrice | currencyNum }}</span>
                          <span>원</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="body4-medium bottom-box2 border-right"
                       style="width:81%;align-items: center;display: flex;justify-content: center;"
                       v-else>3,6,12개월 플랜을 선택하면 혜택을 확인할 수 있습니다.</div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="table-container flex-center" style="padding:20px;margin-top:40px" v-if="selectedOpt">
        <div class="flex-align">
          <div>
            <div class="size-15 sub2 weight-500">멤버십</div>
            <div class="size-16">
              <span class="weight-700 main">{{ memberShipPrice | currencyNum }}</span>
              <span style="margin: 0 2px">원</span>
              <span class="sub3">/{{ dateUnitText }}</span>
            </div>
          </div>
          <div class="circle-plus-st">
            <img :src="svgSrc('u_plus')" class="svg-primary" style="width:20px;height:20px"/>
          </div>
          <div>
            <div class="size-15 sub2 weight-500">호스팅</div>
            <div class="size-16">
              <span class="weight-700 main">{{ hostingPrice | currencyNum }}</span>
              <span style="margin: 0 2px">원</span>
              <span class="sub3">/{{ dateUnitText }}</span>
            </div>
          </div>
          <template v-if="service.service_order.trial">
            <div class="circle-plus-st">
              <img :src="svgSrc('u_plus')" class="svg-primary" style="width:20px;height:20px"/>
            </div>
            <div>
              <div class="size-15 sub2 weight-500">추가 팩/플러그인</div>
              <div class="size-16">
                <span class="weight-700 main">{{ packPluginPrice | currencyNum }}</span>
                <span style="margin: 0 2px">원</span>
              </div>
            </div>
          </template>
          <template v-if="service.service_order.trial && trial_product.app_porting">
            <div class="circle-plus-st">
              <img :src="svgSrc('u_plus')" class="svg-primary" style="width:20px;height:20px"/>
            </div>
            <div>
              <div class="size-15 sub2 weight-500">앱포팅</div>
              <div class="size-16">
                <span class="weight-700 main">{{ trialPrice | currencyNum }}</span>
                <span style="margin: 0 2px">원</span>
              </div>
            </div>
          </template>
          <div class="circle-plus-st" style="padding-top:0">
            <span class="primary size-21 weight-600">=</span>
          </div>
          <div>
            <div class="size-15 sub2 weight-500">총 결제 금액</div>
            <div class="primary size-16"><span class="weight-700">{{ planPrice | currencyNum }}</span>원
              <!--/{{ selectedOpt&&selectedOpt.date_unit ? selectedOpt.date_unit : 1 }}개월-->
            </div>
          </div>
        </div>
      </div>

      <div class="body5 sub3 text-left">· 모든 금액은 부가가치세가 제외된 금액입니다.</div>
      <div class="body5 sub3 text-left">· 서비스 구동을 위해 필수 옵션인 호스팅비가 플랜 주기에 따라 함께 결제 됩니다</div>

      <div class="flex-center">
        <button class="button body2-medium" :class="{'is-primary':enableNext, 'is-sub4':!enableNext}" @click="clickNext"
                style="width:368px;height:48px !important;margin-top:32px;">다음
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "PlanChangeStep1",
    props: {
      service: {
        type: Object
      },
      hosting: {
        type: Object
      },
      baseOrderProduct: {
        type: Object
      },
      selectorStocks: {
        type: Array
      },
      baseTrialProduct: {
        type: Object
      }
    },
    components: {},
    data() {
      return {
        optionArr1: [],
        selectedOpt: {
          id: 0,
          date_unit:0
        },
        order_product: undefined,
        trial_product: undefined
      }
    },
    created() {
      this.order_product = this.baseOrderProduct;
      this.trial_product = this.baseTrialProduct;
      this.initOptions();
    },
    computed: {
      dateUnitText() {
        let date_unit = '1'
        if(this.selectedOpt&&this.selectedOpt.date_unit) {
          date_unit = this.selectedOpt.date_unit.toString()
          if(this.service && this.service.service_order.trial && this.trial_product && this.trial_product.month_free) {
            date_unit = `(${this.selectedOpt.date_unit}+1)`
          }
        }
        return date_unit + '개월'
      },
      packPluginPrice() {
        let price = 0;
        if(this.service && this.service.service_app_order.length>0) {
          let order = this.service.service_app_order
          order.forEach(item=>{
            price += item.subscribe_price * 10 / 11
          })
        }
        return price
      },
      freeMonthPrice() {
        let price = 0
        if(this.selectedOpt) {
          price = this.selectedOpt.price
        }
        return price
      },
      memberShipPrice() {
        let price = 0;
        if(this.memberShip) price = this.memberShip.price * this.order_product.date_unit;
        return price;
      },
      hostingPrice() {
        let price = 0;
        if (this.selectedOpt) price = this.hosting.price * this.selectedOpt.date_unit;
        return price;
      },
      planPrice() {
        let price = this.memberShipPrice + this.hostingPrice + this.trialPrice
        if(this.service.service_order.trial) {
          price += this.packPluginPrice
        }
        return price
      },
      appPortingDiscount() {
        let price = 0;
        if(this.order_product.date_unit===3) {
          price = 74
        } else if(this.order_product.date_unit>3) {
          price = 82
        }
        return price;
      },
      appPortingPrice() {
        let price = 0;
        if(this.order_product.date_unit===3) {
          price = 780000
        } else if(this.order_product.date_unit>3) {
          price = 550000
        }
        return price;
      },
      trialPrice() {
        let price = 0;
        if(this.trial_product.app_porting) price += this.appPortingPrice;
        return price;
      },
      memberShip() {
        if(!this.enableNext) return undefined
        let option_id = this.order_product.order_product_option[0].option_id;
        let stock = find(this.selectorStocks, 'id', option_id);
        let option = find(this.order_product.product.selectors[0].options, 'id', stock.options[0]);
        if(this.order_product.date_unit===1) {
          return option
        } else {
          return find(option.subscriptions, 'date_unit', this.order_product.date_unit);
        }
      },
      enableNext() {
        let item = find(this.order_product.order_product_option, 'option_type', 0);
        return !!item;
      }
    },
    methods: {
      topBoxStyle(idx) {
        let style = {};
        if(idx===0) {
          style.borderLeft = 0
        }
        return style;
      },
      selectTrialProduct(key) {
        if(key==='month_free') {
          this.trial_product.month_free = true;
          this.trial_product.app_porting = false;
        } else {
          this.trial_product.month_free = false;
          this.trial_product.app_porting = true;
        }
      },
      showUsingOption(option, date_unit) {
        if(this.service.status===10) return false;
        if (this.service && this.service.service_order.options.length > 0 && this.service.service_order.options[0].options.length > 0) {
          let selected_option_id = this.service.service_order.options[0].options[0]
          return selected_option_id === option.id && this.service.service_order.date_unit === date_unit
        } else return false
      },
      showUsingMemberShip(option) {
        if(this.service.status===10) return false;
        if (this.service && this.service.service_order.options.length > 0 && this.service.service_order.options[0].options.length > 0) {
          return this.service.service_order.options[0].options[0] === option.id
        } else {
          return false
        }
      },
      selectOpt(option, date_unit) {
        /* 이용중일 경우 예외처리 */
        if(!this.service.service_order.trial && this.showUsingOption(option, date_unit)) {
          return;
        }
        if(date_unit===1) {
          this.trial_product = {
            app_porting:false,
            month_free:false
          }
        }
        let data = this.cloneItem(option);
        data.date_unit = date_unit;
        this.selectedOpt = data;

        this.selectorStocks.forEach(item => {
          if (item.options.indexOf(option.id) > -1) {
            this.order_product.order_product_option = [{
              option_id: item.id,
              quantity: 1,
              option_type: item.option_type
            }];
            this.order_product.date_unit = date_unit;
          }
        })
      },
      initOptions() {
        // 옵션 초기화
        let selectors = this.cloneItem(this.order_product.product.selectors)
        this.optionArr1 = selectors.filter(item => {
          item.disabled = true;
          return item.option_type === 0;
        });

        if (this.optionArr1.length > 0) {
          this.optionArr1[0].disabled = false;

          // 기본 선택 표시
          let options = this.optionArr1[0].options;
          if (options.length > 0) {
            options[0].selected = true;
            if (this.optionArr1.length > 1) this.optionArr1[1].disabled = false;
          }
        }
      },
      originPrice(option) {
        return option.price / (1 - option.discount_rate / 100)
      },
      clickNext() {
        if (!this.enableNext) {
          this.toast('멤버십을 선택하세요.');
          return;
        }
        this.$emit('update:baseOrderProduct', this.order_product);
        this.$emit('update:baseTrialProduct', this.trial_product);
        this.$emit('next')
      }
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  table
    width 100%

  th
    border 1px solid $gray1

  td
    padding 16px
    text-align center
    border 1px solid $gray1

  .td-exp
    background-color $primary-light2
    padding 6px
    border-bottom 0

  .th-empty
    border-top none
    border-left none

  .price-btn-bk
    background-color black
    color white

  .price-btn
    width 210px
    border-radius 8px
    padding 8px 0

  .price-prime
    color black
    border-top 3px solid black

  .price-head
    color $main
    border-top 2px solid $main

  .button-primary
  .button-home-circle
    border 0
    background linear-gradient(322.3deg, #FF6600 22.51%, #F43B00 100%)
    color white

  .button-primary-light
    background-color white
    color $primary
    border 1px solid $primary

  .option-st
    border 1px solid $gray1
    border-radius 8px
    margin-bottom 20px

  .plan-item
    border-top 1px solid $gray2
    padding 16px 0

  .plan-item:first-child
    padding-top 0
    border-top 0

  .tag-primary
    color $primary
    background-color $primary-light2
    border-radius 4px
    font-size 13px
    padding 2px 8px

  .box-info
    background-color $primary-light2
    width 100%
    padding 10px
    display flex
    align-items center
    justify-content center
    border-left 1px solid $gray1
    border-right 1px solid $gray1

  .table-container
    border 1px solid $gray1
    background-color white

  .event-btn
    margin-right 10px
    color white
    padding 2px 4px
    background-color $primary
    border-radius 50px

  .pc
    .option-st
      padding 20px 24px

  .mobile
    .option-st
      padding 12px 16px
      margin-top 8px

  .disabled
    background-color #eee

  .selected
    padding 19px 23px !important
    border 2px solid $primary !important

  .plan-select-wrapper
    display grid
    grid-gap 24px
    grid-template-columns repeat(3, 1fr)

  .top-box
    height 106px
    padding 16px 40px 18px
    border-bottom 1px solid $gray1
    border-left 1px solid $gray1

  .middle-box
    height 342px
    padding 20px
    border-left 1px solid $gray1

/*  .middle-box:first-child
    border-left 0*/

  .bottom-box
    height 209px
    padding 20px
    border-left 1px solid $gray1
    border-bottom 1px solid $gray1

  .bottom-box2
    height 68px
    padding 12px 16px
    border-left 1px solid $gray1
    //border-top 1px solid $gray1
    border-bottom 1px solid $gray1

  .border-right
    border-right 1px solid $gray1

  .sub-box
    background-color $gray4

  .sub-item
    padding 12px
    background-color white
    border-radius 4px
    box-shadow 0px 2px 3px rgba(0, 0, 0, 0.07)
    margin-bottom 12px
    position relative

  .bottom-item
    border 1px solid #e3e3e3
    width 300px
    height 145px
    padding 32px
    text-align center
    background-color white
    position relative
    border-radius 4px

  .sub-unselect
    border 1px solid $gray1

  .sub-select
    border 2px solid $primary-dark

  .content-item
    border-top 2px solid $main

  .table-item
    padding 16px 0
    border-bottom 1px solid $gray1
    border-left 1px solid $gray1

  .show-using-st
    padding 2px 6px
    background-color #F9AA4F
    color white
    margin 0 6px
    font-size 12px
    border-radius 4px
    font-weight 300

  .using-background-st
    background-color $gray4

  .using-background-st1
    background-color $gray2

  .circle-plus-st
    width 30px
    height 30px
    background-color #fff0e5
    border-radius 40px
    padding-top 5px
    margin 0 40px

  .sub-item-check
    position absolute
    top -10px
    right -10px
    z-index 2
    background-color $primary
    width 20px
    height 20px
    border-radius 12px
    display flex
    justify-content center
    align-items center

  .sub-item-check > img
    width 20px
</style>
